import NotificationIcon from "@/nav-localized/assets/header/notification.svg?react";
import AnnouncementsIcon from "@/nav-localized/assets/header/notification/announcements.svg?react";
import TransactionsIcon from "@/nav-localized/assets/header/notification/transactions.svg?react";
import PriceAlertIcon from "@/nav-localized/assets/header/notification/price-alert.svg?react";
import AssetsIcon from "@/nav-localized/assets/header/notification/assets.svg?react";
import SystemMessagesIcon from "@/nav-localized/assets/header/notification/system.svg?react";
import LatestEventsIcon from "@/nav-localized/assets/header/notification/latest.svg?react";
import NewsIcon from "@/nav-localized/assets/header/notification/news.svg?react";
import ArrowRightLLineIcon from "@/nav-localized/assets/header/arrow-right-l-line.svg?react";
import ArrowFill from "@/nav-localized/assets/header/nav/arrow-fill.svg?react";
import TradingServicesIcon from "@/nav-localized/assets/header/notification/trading-services.svg?react";
import { useStoreState } from "../store/useStore";
import {
  stylesText,
  dropDownStylesDesText,
  megaMenuLabel60,
  popperTriggerHover,
  activeRouteStyles
} from "../styles";
import { stylesBg, stylesBgPrimary, stylesLink } from "./styles";
import styles from "./index.module.scss";
import useAction from "./useAction";
import { useCallback, useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { NotificationNumber, NotificationData, NotificationTime, NotificationTitle } from "./types";
import format from "date-fns/format";
import useWatchLocalStorage from "../hooks/useWatchLocalStorage";
import PopOver from "./../PopOver";
import Cookies from "js-cookie";
import clsx from "clsx";

const NotificationPopper = () => {
  const { theme, localeLink, isLogin, isDemoTrading, userInfo } = useStoreState();

  const { getNotification } = useAction();

  const t = useTranslations("messages");

  const [notifications, setNotifications] = useState<NotificationData>({
    announce_count: 0,
    announce_time: 0,
    announce_title: null,
    asset_count: 0,
    asset_time: 0,
    asset_title: null,
    latest_events_count: 0,
    latest_events_time: 0,
    latest_events_title: null,
    latest_events_announcement_count: 0,
    latest_events_announcement_time: 0,
    latest_events_announcement_title: null,
    price_alert_count: 0,
    price_alert_time: 0,
    price_alert_title: null,
    price_alert_total_count: 0,
    system_manager_count: 0,
    system_manager_time: 0,
    system_manager_title: null,
    total_unread_count: 0,
    transaction_count: 0,
    transaction_time: 0,
    transaction_title: null,
    trading_service_announcement_count: 0,
    trading_service_announcement_time: 0,
    trading_service_announcement_title: null,
    news_research_announcement_count: 0,
    news_research_announcement_time: 0,
    news_research_announcement_title: null
  });

  const unreadCount = Math.max(
    0,
    (notifications?.total_unread_count ?? 0) - (notifications?.announce_count ?? 0)
  );

  const items = [
    {
      label: t("announcements"),
      value: "announcements",
      icon: AnnouncementsIcon,
      type: "comp"
    },
    {
      label: t("transactions"),
      value: "transactions",
      icon: TransactionsIcon,
      type: "comp"
    },
    {
      label: t("priceAlert"),
      value: "priceAlert",
      icon: PriceAlertIcon,
      type: "comp"
    },
    {
      label: t("assets"),
      value: "assets",
      icon: AssetsIcon,
      type: "comp"
    },
    {
      label: t("tradingServices"),
      value: "tradingServices",
      icon: TradingServicesIcon,
      type: "comp"
    },
    {
      label: t("systemMessages"),
      value: "systemMessages",
      icon: SystemMessagesIcon,
      type: "comp"
    },
    {
      label: t("latestEvents"),
      value: "latestEvents",
      icon: LatestEventsIcon,
      type: "comp"
    },
    {
      label: t("newsResearch"),
      value: "newsResearch",
      icon: NewsIcon,
      type: "comp"
    }
  ];

  const { value: messageUnreadCount } = useWatchLocalStorage({
    key: "message_unread_count",
    initValue: localStorage?.getItem("message_unread_count")
  });

  const timeConversion = (create_time: number) => {
    if (!create_time) return "--";
    try {
      const now = new Date();
      const messageDate = new Date(create_time);
      const isToday = now.toDateString() === messageDate.toDateString();
      const isYesterday =
        new Date(now.setDate(now.getDate() - 1)).toDateString() === messageDate.toDateString();
      const isThisYear = now.getFullYear() === messageDate.getFullYear();

      if (isToday) {
        return t("today");
      } else if (isYesterday) {
        return t("yesterday");
      } else if (isThisYear) {
        return format(create_time, "MM/dd HH:mm:ss");
      } else {
        return format(create_time, "MM/dd/yyyy HH:mm:ss");
      }
    } catch (error) {
      console.log("Error formatting date:", error);
      return "--";
    }
  };

  const handleGetNotificationUnreadCount = useCallback(async () => {
    try {
      const res = await getNotification();
      const response = res as unknown as { code: number; data: NotificationData };
      if (response.code === 200) {
        setNotifications({
          ...response.data,
          total_unread_count: response.data.total_unread_count || 0
        });
      }
    } catch (error) {
      console.info(error);
    }
  }, []);

  useEffect(() => {
    handleGetNotificationUnreadCount();
  }, [messageUnreadCount]);

  const cookieAccountType = Cookies.get("Global-AccountType");

  if (
    !isLogin ||
    isDemoTrading ||
    cookieAccountType === "NORMAL_SUB_ACCOUNT" ||
    userInfo?.account_type === "NORMAL_SUB_ACCOUNT"
  ) {
    return null;
  }
  return (
    <PopOver
      trigger="group-hover"
      anchor="top-right"
      containerClassName={clsx(
        "flex items-center pl-[24px] cursor-pointer",
        stylesText({
          mode: theme
        }),
        popperTriggerHover({ mode: theme })
      )}
      onMouseEnter={() => {
        window?.reportTrack?.("Heading_Notification_Viewall_Click", {});
      }}
      content={
        <div className={`${stylesBg({ mode: theme })} w-[380px] h-[368px] pb-3 overflow-hidden`}>
          <div className="w-full flex items-center justify-between h-[44px] px-[24px] py-[12px]">
            <div
              className={`flex items-center gap-2 text-base leading-[20px] ${stylesText({ mode: theme })}`}
            >
              <span className="font-medium">{t("notifications")}</span>
              {unreadCount > 0 && (
                <span
                  className="flex h-[20px] min-w-[20px] items-center justify-center rounded-[10px] bg-[#F13C54] px-1 text-sm leading-[20px] text-white"
                  dir="ltr"
                  style={{ unicodeBidi: "isolate" }}
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </div>
            <a
              href={`${localeLink}/message-center`}
              className={`flex items-center gap-1 text-sm leading-[18px] ${stylesLink({ mode: theme })}`}
            >
              {t("viewAll")}
              <ArrowRightLLineIcon className="rtl-mirror" />
            </a>
          </div>
          <ul
            className={clsx(
              "w-full h-[calc(100%-44px)]",
              theme === "dark" ? styles["scroll-container-dark"] : styles["scroll-container"]
            )}
          >
            {items.map((item, index) => {
              const notificationCount =
                notifications?.[
                  NotificationNumber[item.value as keyof typeof NotificationNumber]
                ] || 0;
              const notificationTime =
                notifications?.[NotificationTime[item.value as keyof typeof NotificationTime]] || 0;

              const notificationTitle =
                notifications?.[NotificationTitle[item.value as keyof typeof NotificationTitle]] ||
                "";
              const notificationUrl = `${localeLink}/message-center?type=${item.value}`;
              return (
                <li
                  key={index}
                  className={`flex w-full cursor-pointer items-center gap-2 px-6 py-3 text-[16px] min-h-[64px] leading-[24px] ${stylesText({ mode: theme })}`}
                >
                  <a href={notificationUrl} className="w-full flex items-center gap-4 group/second">
                    <item.icon className="w-[20px] h-[20px] min-w-[20px]" />
                    <div className="flex flex-col gap-[2px] flex-1">
                      <div className="flex w-full items-center justify-between">
                        <div className="text-base leading-[20px] font-medium flex items-center">
                          <span className={popperTriggerHover({ mode: theme })}>{item.label}</span>
                          <ArrowFill
                            className={clsx(
                              "w-[20px] text-light-primary h-[20px] shrink-0 ms-[4px] transform opacity-0 translate-x-[-4px] rtl:translate-x-[4px] rtl:scale-x-[-1] group-hover/second:[transition:all_300ms_ease-out] group-hover/second:translate-x-0 group-hover/second:opacity-100",
                              activeRouteStyles({ mode: theme })
                            )}
                          />
                        </div>
                        {item.type === "comp" &&
                        item.value !== "announcements" &&
                        notifications &&
                        notificationCount > 0 ? (
                          <span
                            className="flex h-[20px] min-w-[20px] items-center justify-center rounded-[10px] bg-[#F13C54] px-1 text-sm leading-[20px] text-white"
                            dir="ltr"
                            style={{ unicodeBidi: "isolate" }}
                          >
                            {notificationCount > 99 ? "99+" : notificationCount}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      {item.type === "comp" ? (
                        <div
                          className={`${megaMenuLabel60({ mode: theme })} text-sm leading-[18px] max-w-[288px] overflow-hidden text-ellipsis whitespace-nowrap`}
                        >
                          {notificationTitle ? notificationTitle : t("noNews")}
                        </div>
                      ) : null}
                      {notificationTime ? (
                        <div
                          className={`${dropDownStylesDesText({ mode: theme })} text-sm leading-[18px]`}
                        >
                          {timeConversion(notificationTime)}
                        </div>
                      ) : null}
                    </div>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      }
    >
      <div className="relative w-[24px] !h-[24px]">
        <NotificationIcon />
        {unreadCount > 0 && (
          <div
            className={`${stylesBgPrimary({
              mode: theme
            })}`}
          ></div>
        )}
      </div>
    </PopOver>
  );
};

export default NotificationPopper;
